<template>
  <li :class="classes">
    <m4-button
      @click="click"
      variant="primary-link"
      size="full-width"
      class="menu__item__button"
      v-bind="itemButtonProps()"
    >
      <template v-if="hasChildren">
        <span class="menu__item__button__text">{{ item.text }}</span>
        <span class="menu__item__button__arrow">
          <m4-icon icon="angle-down"></m4-icon>
        </span>
      </template>
      <template v-else>
        {{ item.text }}
      </template>
    </m4-button>
    <m4-menu v-if="hasChildren && opened" :items="item.children" class="menu--submenu"></m4-menu>
  </li>
</template>

<script>
export default {
  name: "M4MenuItem",
  data() {
    return {
      opened: false
    };
  },
  props: {
    item: Object
  },
  computed: {
    classes() {
      let classes = ["menu__item"];
      if (this.opened) {
        classes.push("menu__item--open");
      }
      return classes;
    },
    hasChildren() {
      return this.item.children !== undefined && this.item.children.length > 0;
    }
  },
  methods: {
    itemButtonProps() {
      if (this.item.to) {
        return {
          tag: "router-link",
          to: this.item.to
        };
      } else if (this.item.href) {
        return {
          tag: "a",
          href: this.item.href
        };
      }
      return {
        tag: "a"
      };
    },
    click(e) {
      if (this.hasChildren) {
        e.preventDefault();
        this.opened = !this.opened;
      }
    }
  }
};
</script>
